/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
Component: src/components/OfferingContent.tsx
*/

import React from 'react';
import {
  BookTitleDescription,
  RowWrapper,
  BookCopyContent,
  BookImageBorder,
  ALinkButtonWrapper,
  BtnWrapper,
  LinkWrapper,
  BookRow,
  AMobileLinkButtonWrapper,
} from './HomePage.css';

import Image from 'next/image';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import uuid from 'react-uuid';
import { useIsMobile } from '../../../hooks/useIsMobile';

export default function BooksContent({}: IBooksContentProps) {
  const titles = [
    'Integrating D3.js with React',
    'The Blockchain Developer',
    'React and Libraries',
  ];
  const descriptions = [
    'Learn to Bring Data Visualization to Life. Integrate D3.js into a React TypeScript project & create a chart component working in harmony w/ React.',
    'The Blockchain Developer: A Practical Guide for Designing, Implementing, Publishing, Testing, and Securing Distributed Blockchain-based Projects.',
    'React and Libraries: Harness the power of React and the related libraries that you need to know to deliver a successful front-end implementations.',
  ];
  const imageCover = [
    '/images/integrate-d3.png',
    '/images/the-blockchain-developer.png',
    '/images/react-book.jpg',
  ];
  const buyURL = [
    'https://www.apress.com/gp/book/9781484270516',
    'https://www.apress.com/gp/book/9781484248461',
    'https://link.springer.com/book/10.1007/978-1-4842-6696-0',
  ];

  const isMobile = useIsMobile();

  return (
    <>
      <AwesomeSlider style={{ height: isMobile ? '120em' : '150em' }}>
        {titles.map((_item, index) => (
          <RowWrapper key={`RowWrapper-div-${uuid()}`} id="row-wrapper">
            <BookRow id="book-row">
              <a target="_blank" rel="noopener noreferrer" href={buyURL[index]}>
                <LinkWrapper id="link-wrapper">
                  <BookImageBorder id="book-image-border">
                    <Image
                      alt={titles[index]}
                      layout="fill"
                      objectFit="fill"
                      src={imageCover[index]}
                    />
                  </BookImageBorder>
                </LinkWrapper>
              </a>
            </BookRow>
            <BookRow>
              <BookCopyContent id="book-copy-content">
                <BookTitleDescription>
                  {descriptions[index]}
                  <AMobileLinkButtonWrapper>
                    <a target="_blank" rel="noopener noreferrer" href={buyURL[index]}>
                      BUY NOW
                    </a>
                  </AMobileLinkButtonWrapper>
                </BookTitleDescription>
                <BtnWrapper>
                  <ALinkButtonWrapper width="5em">
                    <a target="_blank" rel="noopener noreferrer" href={buyURL[index]}>
                      BUY
                    </a>
                  </ALinkButtonWrapper>
                </BtnWrapper>
              </BookCopyContent>
            </BookRow>
          </RowWrapper>
        ))}
      </AwesomeSlider>
    </>
  );
}

interface IBooksContentProps {
  isLightsOn: boolean;
  colorDay: string;
  colorNight: string;
}
